import React, { useState, useRef } from 'react';
import { Layout } from 'antd';
import Navbar from './components/Navbar/Navbar';
import SideMenu from './components/SideMenu/SideMenu';
import Login from './pages/Login/Login';
import Users from './pages/Users/Users';
import UserDetail from './pages/Users/UserDetail';
import Videos from './pages/Videos/Videos';
import VideoDetail from './pages/Videos/VideoDetail';
import Images from './pages/Images/Images';
import ImageDetail from './pages/Images/ImageDetail';
import Explore from './pages/Explore/Explore';
import ExploreDetail from './pages/Explore/ExploreDetail';
import CreateExplore from './pages/Explore/CreateExplore';
import Categories from './pages/Categories/Categories';
import CategoryDetail from './pages/Categories/CategoryDetail';
import CreateCategory from './pages/Categories/CreateCategory';
import Feed from './pages/Feed/Feed';
import Support from './pages/Support/Support';
import Dashboard from './pages/Dashboard/Dashboard';
import SystemPage from './pages/System/System';
import CreditProducts from './pages/CreditProducts/CreditProducts';
import CreateCreditProduct from './pages/CreditProducts/CreateCreditProduct';
import CreditProductDetail from './pages/CreditProducts/CreditProductDetail';
import Tools from './pages/Studios/Studios';
import CreateTool from './pages/Studios/CreateStudio';
import ToolDetail from './pages/Studios/StudioDetail';
import Notifications from './pages/Notifications/Notifications';
import AppVersions from './pages/AppVersions/AppVersions';
import AppVersionDetail from './pages/AppVersions/AppVersionDetail';
import CreateAppVersion from './pages/AppVersions/CreateAppVersion';
import Banners from './pages/Banners/Banners';
import CreateBanner from './pages/Banners/CreateBanner';
import BannerDetail from './pages/Banners/BannerDetail';
import RemoteConfigs from './pages/RemoteConfigs/RemoteConfigs';
import CreateRemoteConfig from './pages/RemoteConfigs/CreateRemoteConfig';
import RemoteConfigDetail from './pages/RemoteConfigs/RemoteConfigDetail';
import Tabs from './pages/Tabs/Tabs';
import Search from './pages/Search/Search';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

const { Content } = Layout;

// Sidebar navigations carry a fresh `sidebarNav` stamp in location state; using it
// as the Routes key remounts the page so it starts with default state. The ref keeps
// the key stable when a page later updates the URL (e.g. search params) without state.
const AppRoutes = () => {
  const location = useLocation();
  const navKeyRef = useRef(null);
  if (location.state?.sidebarNav) navKeyRef.current = location.state.sidebarNav;

  return (
    <Routes key={navKeyRef.current}>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/users" element={<Users />} />
      <Route path="/user/:id" element={<UserDetail />} />
      <Route path="/videos" element={<Videos />} />
      <Route path="/video/:id" element={<VideoDetail />} />
      <Route path="/images" element={<Images />} />
      <Route path="/image/:id" element={<ImageDetail />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/explore/create" element={<CreateExplore />} />
      <Route path="/explore/:id" element={<ExploreDetail />} />
      <Route path="/categories" element={<Categories />} />
      <Route path="/categories/:id" element={<CategoryDetail />} />
      <Route path="/categories/create" element={<CreateCategory />} />
      <Route path="/feed" element={<Feed />} />
      <Route path="/support" element={<Support />} />
      <Route path="/system" element={<SystemPage />} />
      <Route path="/credit-products" element={<CreditProducts />} />
      <Route path="/credit-products/create" element={<CreateCreditProduct />} />
      <Route path="/credit-products/:id" element={<CreditProductDetail />} />
      <Route path="/tools" element={<Tools />} />
      <Route path="/tools/create" element={<CreateTool />} />
      <Route path="/tools/:id" element={<ToolDetail />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/banners" element={<Banners />} />
      <Route path="/banners/create" element={<CreateBanner />} />
      <Route path="/banners/:id" element={<BannerDetail />} />
      <Route path="/tabs" element={<Tabs />} />
      <Route path="/search" element={<Search />} />
      <Route path="/app-versions" element={<AppVersions />} />
      <Route path="/app-versions/create" element={<CreateAppVersion />} />
      <Route path="/app-versions/:id" element={<AppVersionDetail />} />
      <Route path="/remote-configs" element={<RemoteConfigs />} />
      <Route path="/remote-configs/create" element={<CreateRemoteConfig />} />
      <Route path="/remote-configs/:id" element={<RemoteConfigDetail />} />
    </Routes>
  );
};

function App() {
  const [collapsed, setCollapsed] = useState(false);
  const token = localStorage.getItem('token');

  if (!token) {
    return <Login />;
  }

  const toggleSider = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Router>
      <Layout className="app">
        <Navbar collapsed={collapsed} onCollapse={toggleSider} />
        <Layout>
          <SideMenu collapsed={collapsed} onCollapse={toggleSider} />
          <Content className={`content ${collapsed ? 'content-collapsed' : ''}`}>
            <AppRoutes />
          </Content>
        </Layout>
      </Layout>
    </Router>
  );
}

export default App;
